const texts = {
  next: 'Next',
  previous: 'Previous'
};

export const t = key => texts[key];
